import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { CommercialSeries, User } from '@bytel/checkout';

import { AppService } from '@services/app.services';
import { ConfigurationService } from '@services/configuration.service';

import { ModalComponent } from '@shared/modal/modal.component';
import { ModalTypes } from '@shared/modal/modal.interface';

@Component({
    selector: 'checkout-eligiblity-error-modal',
    standalone: true,
    imports: [CommonModule, ModalComponent],
    templateUrl: './eligiblity-error-modal.component.html',
    styleUrls: [],
})
export class EligiblityErrorModalComponent extends ModalComponent {
    @Input() commercialSeries: CommercialSeries;
    @Input() user: User;

    type: ModalTypes = 'error';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_eligibilite',
        categorieClic: 'Modale_erreur',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Redirect_Eligibilite',
        categorieClic: 'Modale_erreur_eligibilite',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_eligibilite',
    };

    title: string = `Vous n'êtes pas éligible à la Série Spéciale Bbox.`;
    body: string =
        "Cette offre est réservée à certains clients mobile Bouygues Telecom. Rassurez-vous, nous avons d'autres offres Box internet à vous proposer.";

    private appService = inject(AppService);
    private configService: ConfigurationService = inject(ConfigurationService);
    public ngOnInit(): void {
        this.getTitleAndBody();
        this.modalRef.crossClicked.subscribe(() => {
            this.appService.navigateTo(this.configService.getData().global.wall.fai_eligiblity_result);
        });
    }

    public redirect(): void {
        this.appService.navigateTo(this.configService.getData().global.wall.fai_eligiblity_result);
    }

    private getTitleAndBody(): void {
        if (this.commercialSeries === CommercialSeries.B_AND_YOU) {
            this.title = `${
                this.user?.prenom ? this.user.prenom + ', vous' : 'Vous'
            } n'êtes pas éligible à la Série client B&YOU.`;
            this.body =
                "Cette offre est réservée aux clients B&YOU. Rassurez-vous, nous avons d'autres offres Box internet à vous proposer.";
        }
    }
}
